import { restoreProtectedEmails } from './email-protection';

// Reveal contacts even when the main application is delayed or fails to load.
restoreProtectedEmails(document);
